/**
 * @generated SignedSource<<4601b1d39964da8fffc830f933eac0e1>>
 * @relayHash 2ed661fd98ae15fa8cc77403a06af2a3
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 2ed661fd98ae15fa8cc77403a06af2a3

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ccnId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offerType"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tableType"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "ccnId",
        "variableName": "ccnId"
      },
      {
        "kind": "Variable",
        "name": "offerType",
        "variableName": "offerType"
      },
      {
        "kind": "Variable",
        "name": "tableType",
        "variableName": "tableType"
      }
    ],
    "concreteType": "UrlResponse",
    "kind": "LinkedField",
    "name": "generateTableParametrage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "GenerateTableParametrageMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "GenerateTableParametrageMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "id": "2ed661fd98ae15fa8cc77403a06af2a3",
    "metadata": {},
    "name": "GenerateTableParametrageMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "18290a853ea50520be57359ab8b1448a";

export default node;
